<section class="w-full">
  <!-- HEADER -->
  <div class="mb-5 grid grid-cols-1 gap-4 lg:grid-cols-7 lg:items-center">
    <div class="lg:col-span-5">
      <div class="w-fit rounded-2xl border border-gray-300 bg-gradient-to-r from-gray-50 to-white px-5 py-3">
        <div class="border-l-4 border-gray-800 pl-4">
          <p class="text-xs font-semibold uppercase tracking-[0.18em] text-gray-500">
            Subscription Settings
          </p>

          <h2 mat-dialog-title class="!m-0 mt-1 flex flex-wrap items-center gap-2 text-2xl font-bold tracking-tight text-gray-900">
            <mat-icon class="text-gray-400">credit_card</mat-icon>

            <span class="text-gray-900" [innerHTML]="companyData['Name']"></span>

            <div id="companysettingsfor" class="hidden">{{ companyID }}</div>
          </h2>
        </div>
      </div>
    </div>
  </div>

  <!-- TABS -->
  <div class="rounded-2xl border border-gray-300 bg-white">
    <mat-tab-group [(selectedIndex)]="selectedIndex" class="custom-tabs">
      <mat-tab *ngFor="let tab of tabs" [label]="tab.name">
        <ng-template mat-tab-label>
          <div class="inline-flex items-center gap-2">
            <mat-icon>{{ tab.icon }}</mat-icon>
            <span>{{ tab.name }}</span>
          </div>
        </ng-template>

        <div class="border-t border-gray-300 p-4 sm:p-5">
          <ng-container *ngIf="tab.name === 'Users' && selectedIndex === 0">
            <app-users-table class="mt-1"></app-users-table>
          </ng-container>

          <ng-container *ngIf="tab.name === 'Social Page/Site' && selectedIndex === 1">
            <app-site-table class="mt-1" [companyID]="companyID"></app-site-table>
          </ng-container>

          <ng-container *ngIf="tab.name === 'Platforms' && selectedIndex === 2">
            <app-social-ai-admin-platforms-table
              class="mt-1"
              [companyID]="companyID"
            >
            </app-social-ai-admin-platforms-table>
          </ng-container>

          <ng-container *ngIf="tab.name === 'Post Category' && selectedIndex === 3">
            <app-social-ai-admin-rss-feed-table
              class="mt-1"
              [companyID]="companyID"
            >
            </app-social-ai-admin-rss-feed-table>
          </ng-container>

          <ng-container *ngIf="tab.name === 'Video Templates' && selectedIndex === 4">
            <app-social-ai-admin-manage-video-template-table
              class="mt-1"
              [companyID]="companyID"
            >
            </app-social-ai-admin-manage-video-template-table>
          </ng-container>

          <ng-container *ngIf="tab.name === 'Publio Plan' && selectedIndex === 5">
            <app-social-publisher-commercial-model-table class="mt-1">
            </app-social-publisher-commercial-model-table>
          </ng-container>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</section>